import type { PropType } from 'vue'
import type { IListCOnfig } from '..'
import type { IConfig } from './types'
export const BdTableProps = {
  config: {
    type: Object as PropType<IConfig>,
    default: null,
    required: true
  }
}
export const BdListProps = {
  config: {
    type: Object as PropType<IListCOnfig>,
    default: null,
    required: true
  },
  attrs: {
    type: Object as PropType<Record<string, any>>
  }
}
